<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<button-search ref="buttonSearch" placeholder="要搜索的货物编号" @search="searchEvent" class="pt-3 pb-1">
			<!-- 左边 -->
			<template #left>
				<el-button type="primary" size="mini" icon="el-icon-download">导出</el-button>
			</template>
		
			<!-- 高级搜索表单 -->
			<template #form>
				<el-form inline ref="form" :model="form" label-width="80px">
					<el-form-item label="客户名" class="mb-0">
						<el-select v-model="search.kh_id" filterable style="width: 90%;" size="mini">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="出仓入仓" class="mb-0">
						<el-radio-group v-model="search.crc">
						      <el-radio-button label="0">入仓</el-radio-button>
						      <el-radio-button label="1">出仓</el-radio-button>
							  <el-radio-button label="2">全部</el-radio-button>
						    </el-radio-group>
					</el-form-item>
					<el-form-item label="货物编号" class="mb-0"><el-input v-model="search.bh" size="mini"></el-input></el-form-item>
					<el-form-item class="mb-0">
						<el-button type="info" size="mini" @click="searchEvent">搜索</el-button>
						<el-button size="mini" @click="clearSearch">清空筛选条件</el-button>
					</el-form-item>
				</el-form>
			</template>
		</button-search>
		<div>
			<el-table
				:data="kcmxList"
				style="width: 100%"
				size="mini"
				@selection-change="handleSelectionChange"
				row-key="id"
				:tree-props="{ children: 'child', hasChildren: 'hasChildren' }"
				@current-change="handleCurrentChange"
				 :max-height="maxHeight"
			>
				<el-table-column type="selection" width="50" align="center"></el-table-column>
				<el-table-column width="120">
					<template slot="header" slot-scope="scope">
						编号
					</template>
					<template slot-scope="scope">
						{{ scope.row.bh }}
					</template>
				</el-table-column>
				<el-table-column width="80">
					<template slot="header" slot-scope="scope">
						货物名称
					</template>
					<template slot-scope="scope">
						{{ scope.row.name }}
					</template>
				</el-table-column>
				<el-table-column align="center" width="120">
					<template slot="header" slot-scope="scope">
						客户
					</template>
					<template slot-scope="scope">
						<el-button type="success" size="mini" plain>{{ scope.row.khdata.name }}</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center" width="120">
					<template slot="header" slot-scope="scope">
						仓库
					</template>
					<template slot-scope="scope">
						<el-button type="success" size="mini" plain>{{ scope.row.ckdata.name }}</el-button>
					</template>
				</el-table-column>
				<el-table-column align="center" width="260">
					<template slot="header" slot-scope="scope">
						坐标
					</template>
					<template slot-scope="scope">
						<el-button type="success" size="mini" plain>{{ scope.row.zbdata.wz }}</el-button>
					</template>
				</el-table-column>
				<el-table-column width="100" align="center">
					<template slot="header" slot-scope="scope">
						入仓数量
					</template>
					<template slot-scope="scope">
						{{ scope.row.rc }}
					</template>
				</el-table-column>
				<el-table-column align="center" width="100">
					<template slot="header" slot-scope="scope">
						出仓数量
					</template>
					<template slot-scope="scope">
						{{ scope.row.cc }}
					</template>
				</el-table-column>
				<el-table-column align="center" width="100">
					<template slot="header" slot-scope="scope">
						流水件数
					</template>
					<template slot-scope="scope">
						{{ scope.row.js }}
					</template>
				</el-table-column>
				<el-table-column align="center">
					<template slot="header" slot-scope="scope">
						流水面积
					</template>
					<template slot-scope="scope">
						{{ scope.row.mj }}
					</template>
				</el-table-column>
				<el-table-column align="center">
					<template slot="header" slot-scope="scope">
						流水体积
					</template>
					<template slot-scope="scope">
						{{ scope.row.tj }}
					</template>
				</el-table-column>
				<el-table-column align="center">
					<template slot="header" slot-scope="scope">
						关联订单
					</template>
					<template slot-scope="scope">
						{{ scope.row.gldd }}
					</template>
				</el-table-column>
				<el-table-column align="center" width="200">
					<template slot="header" slot-scope="scope">
						操作时间
					</template>
					<template slot-scope="scope">
						{{ scope.row.create_time }}
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
	</div>
</template>

<script>
	import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	components: {
		buttonSearch
	},
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			form: {
				
			},
			search:{
				bh:'',
				kh_id: '',
				crc: 2,
				// ck_id:'',
			},
			createModel: false,
			dialogType: 'kcmxls',
			preUrl: 'kcmxls', //api
			kcmxList: [],
			maxHeight: 0,
			tjsl: 0,
			khlist:[]
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 240;
		});
		this.axios.get('/admin/khxxs', { token: true }).then(res => {
			this.khlist = res.data.data;
		});
	},
	methods: {
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}&bh=${this.search.bh}&kh_id=${this.search.kh_id}&crc=${this.search.crc}`;
		},
		// 处理列表结果
		getListResult(e) {
			this.kcmxList = e.list;
			// for (let a of e.list) {
			// 	this.tjsl += a.kcsl;
			// }
			// const h = this.$createElement;
			// this.$message({
			// 	showClose: true,
			// 	customClass:'ts',
			// 	duration: 5000,
			// 	message: h('p', null, [
			// 		h('span', { style: 'font-size: 18px' }, '统计信息 '), 
			// 		h('p', { style: 'font-size: 14px;color:#838383' }, '库存总量：' + this.tjsl)
			// 		]
			// 	)
			// });
			// console.log(this.tjsl);
		},
		openModel(type, item = false) {
			// 初始化表单
			switch (type) {
				// 初始化添加管理员
				case 'kcmx':
					this.form.kcmx = {
						id: item.id,
						mc: item.cpid.cpmc,
						ggbm: item.ggbm,
						rklj: item.rklj,
						cplx: item.cplx,
						cbj: item.cbj,
						cjr: item.cjr.name,
						cpbm: item.cpid.cpbm,
						dw: item.dw,
						create_time: item.create_time,
						update_time: item.update_time,
						scrq: item.scrq,
						bzq: item.cpid.bzqts,
						cpfl: item.cpfl,
						ckcw: item.ckcw.name,
						cklj: item.cklj,
						ggmc: item.ggmc,
						kcsl: item.kcsl
					};
					break;
			}
			this.createModel = true;
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		handleCurrentChange(val) {
			this.currentRow = val;
		},
		// 清空筛选条件
		clearSearch() {
			this.search = {
				bh:'',
				kh_id: '',
				crc: 2,
			};
		},
		// 搜索事件
		searchEvent(e = false) {
			// 简单搜索
			if (typeof e === 'string') {
				this.search.bh = e
				this.getList()
				return
			}
			// 高级搜索
			this.getList()
		},
		
	}
};
</script>

<style>
	.ts{
		min-width: 200px;
		left:90%;
		background-color:#fff;
		box-shadow: 2px 2px 10px #cbcbcb;
	}
</style>
